import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { AppConstants } from 'src/app/common/app.constants';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { SaleItemModel } from './model/sale-item.model';
import { SaleItemService } from './sale-item.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { EmployeeCategoryModel } from '../../employees/employee-category/employee-category/model/employee-category.model';
import { GroupItemListPopupComponent } from './group-item-list-popup/group-item-list-popup.component';
import { GroupItemEditPopupComponent } from './group-item-edit-popup/group-item-edit-popup.component';
import { PermissionService } from 'src/app/auth/permission.service';
import { ShopPricePopupComponent } from './shop-price-popup/shop-price-popup.component';
import { StorageService } from 'src/app/common/services/storage.service';


@Component({
  selector: 'app-sale-item',
  templateUrl: './sale-item.component.html',
  styleUrl: './sale-item.component.scss',
  standalone: false
})
export class SaleItemComponent implements AfterViewInit {
  AppConstants = AppConstants;
  salesList: SaleItemModel[] = [];
  IsDownloading = false;
  groupItems: any[] = []; // Add this property
  itemClasses: any[] = []; // Add item classes property


  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "sale_item.code",
    },
    {
      title: "Name",
      column: "sale_item.name",
    },
    {
      title: "Short Name",
      column: "sale_item.short_name",
    },
    {
      title: "Item Type",
      column: "sale_item.sale_item_type",
      operators: [{ title: 'in', operator: 'arroverlaps' }],
      type: "list",
      values: [
        { title: "Regular item", value: 1 },
        { title: "Customizable", value: 2 },
        { title: "Combo", value: 3 },
        { title: "Group item", value: 999 }
      ]
    },
    {
      title: "Sales Channel",
      column: "sale_item.sales_channel",
      type: "list",
      values: [
        { title: "Instore", value: "instore" },
        { title: "Online", value: "online" }
      ]
    },
    {
      title: "Hot Item",
      column: "sale_item.hot_item",
      operators: [{ title: 'in', operator: 'arroverlaps' }],
      type: "list",
      values: [
        { title: "Hot item 1", value: 1 },
        { title: "Hot item 2", value: 2 },
        { title: "Hot item 3", value: 3 },
        { title: "Drive through", value: 999 }
      ]
    },
    {
      title: "Is Valid",
      column: "sale_item.is_valid",
      type: "list",
      values: [
        { title: "Yes", value: "1" },
        { title: "No", value: "0" }
      ]
    },
    {
      title: "Item Class",
      column: "sale_item.sub_class_id",
      type: "list",
      values: [
        { title: "Loading...", value: "" } // Add placeholder while loading
      ]
    }
  ];
  displayedColumns = ['code', 'name', 'type', 'short_name', 'group', 'class', 'price', 'valid', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: SaleItemModel;
  showSummaryPanel: boolean = false;
  //salesDataSource!: MatTableDataSource<any>;
  selection = new SelectionModel<SaleItemModel>(true, []);
  dataSource = new MatTableDataSource(this.salesList);
  customization: any;
  combo: any;

  // Column name mapping for backward compatibility
  private columnMapping: { [key: string]: string } = {
    'sale_items.code': 'sale_item.code',
    'sale_items.name': 'sale_item.name',
    'sale_items.short_name': 'sale_item.short_name',
    'sale_items.item_type': 'sale_item.sale_item_type',
    'sale_items.fixed_price': 'sale_item.fixed_price',
    'sale_items.is_valid': 'sale_item.is_valid'
  };
  permission: any;
  userData: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private saleItemService: SaleItemService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    public permissionService: PermissionService,
    private router: Router, private stateManagerService: StateManagerService,
    private storageService: StorageService,
    private changeDetecter: ChangeDetectorRef) {
    this.permission = permissionService.getPagePermission("sale-item");
    this.salesList = [];
    const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
    }
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.getAllCustomization();
    this.getAllCombo();
    this.loadKitchenListForSession();
    this.loadTaxListForSession();
    this.loadUomListForSession();
    this.loadItemTypeListForSession();

    this.storageService.clearSessionByName(AppConstants.SESSION_VAR_GROUP_ITEMS);
    this.loadGroupItemsForFilter();
    this.loadItemClassesForFilter();
    // this.loadData();
  }

  getAllCustomization() {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [], // Empty advanced search array
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: []
      }
    };
    this.saleItemService.getCustomizationList(requestData).subscribe((response: any) => {
      if (response.status === 'SUCCESS') {
        this.customization = response.data.customizations;
        // Store customization data in session storage
        if (this.customization !== null && this.customization !== undefined) {
          sessionStorage.setItem(AppConstants.SESSION_VAR_SALE_ITEM_CUST_OPTS, JSON.stringify(this.customization));
        }
      }
    });
  }

  getAllCombo() {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [], // Empty advanced search array
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: []
      }
    };

    // Use saleItemsCombo as the source for combo options
    this.saleItemService.getComboList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.combo = response.data.combo_options || [];
          // Store combo data in session storage
          if (this.combo !== null && this.combo !== undefined) {
            sessionStorage.setItem(AppConstants.SESSION_VAR_SALE_ITEM_COMBO_OPTS, JSON.stringify(this.combo));
          }
        }
      }
    );
  }
  /**
   * Load group items for filter dropdown
   */
  loadGroupItemsForFilter(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]
      }
    };

    this.saleItemService.getGroupItemList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.groupItems = response.data.group_items || [];

          // Find the Group Item filter and populate its values
          const groupItemFilter = this.filter.find(f => f.column === "sale_item.group_item_id");
          if (groupItemFilter && groupItemFilter.values) {
            groupItemFilter.values = [
              { title: "No Group", value: "null" },
              ...this.groupItems.map((item: any) => ({
                title: item.name,
                value: item.id.toString()
              }))
            ];
          }

          if (this.groupItems !== null && this.groupItems !== undefined) {
            sessionStorage.setItem(AppConstants.SESSION_VAR_GROUP_ITEMS, JSON.stringify(this.groupItems));
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to load group items for filter',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    );
  }

  /**
   * Load item classes for filter dropdown
   */
  loadItemClassesForFilter(): void {
    console.log('Loading item classes for filter...');
    this.saleItemService.getAllItemClasses().subscribe(
      (response: any) => {
        console.log('Item classes response:');
        if (response.status === "SUCCESS") {
          this.itemClasses = response.data.item_classes || [];
          console.log('Loaded item classes:');

          // Find the Item Class filter and populate its values
          const itemClassFilter = this.filter.find(f => f.column === "sale_item.sub_class_id");
          console.log('Found item class filter:');
          if (itemClassFilter && itemClassFilter.values) {
            // Replace all values with item classes
            itemClassFilter.values.length = 0; // Clear existing values
            if (this.itemClasses.length > 0) {
              itemClassFilter.values.push(
                ...this.itemClasses.map((itemClass: any) => ({
                  title: itemClass.name,
                  value: itemClass.id.toString()
                }))
              );
            } else {
              itemClassFilter.values.push({ title: "No item classes found", value: "" });
            }
            console.log('Updated filter values:');

            // Trigger change detection to update the search filter component
            this.changeDetecter.detectChanges();
          }

          if (this.itemClasses !== null && this.itemClasses !== undefined) {
            sessionStorage.setItem(AppConstants.SESSION_VAR_CLASSES, JSON.stringify(this.itemClasses));
          }
        } else {
          console.error('Failed to load item classes:');
          let snackBarData: SnackBarData = {
            message: response.message || 'Failed to load item classes',
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      (error) => {
        console.error('Error loading item classes:', error);
        let snackBarData: SnackBarData = {
          message: 'Failed to load item classes for filter',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    );
  }

  loadKitchenListForSession(): void {
    let requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: "code", order: "asc" }],
      },
    };
    this.saleItemService.getkitchenList(requestData).subscribe((response: any) => {
      if (response.status === "SUCCESS" && response.data?.kitchens) {
        sessionStorage.setItem(AppConstants.SESSION_VAR_KITCHENS, JSON.stringify(response.data.kitchens));
      }
    });
  }

  loadTaxListForSession(): void {
    let requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: "code", order: "asc" }],
      },
    };
    this.saleItemService.getTaxList(requestData).subscribe((response: any) => {
      if (response.status === "SUCCESS" && response.data) {
        sessionStorage.setItem(AppConstants.SESSION_VAR_TAXES, JSON.stringify(response.data));
      }
    });
  }

  loadUomListForSession(): void {
    let requestData = {
      search: {
        filters: { simpleSearch: [], advSearch: [], scope: { limit: 50, offset: 0 } },
        sort: [{ column: "u.name", order: "asc" }]
      }
    };
    this.saleItemService.getUomList(requestData).subscribe((response: any) => {
      if (response.status === "SUCCESS" && response.data?.uoms) {
        sessionStorage.setItem(AppConstants.SESSION_VAR_UOMS, JSON.stringify(response.data.uoms));
      }
    });
  }

  loadItemTypeListForSession(): void {
    let requestData = {
      search: {
        filters: { simpleSearch: [], advSearch: [], scope: { limit: 100, offset: 0 } },
        sort: []
      }
    };
    this.saleItemService.getItemTypeList(requestData).subscribe((response: any) => {
      if (response.status === "SUCCESS" && response.data?.item_types) {
        const itemTypes = response.data.item_types.map((t: any) => ({
          id: Number(t.id),
          name: t.title || t.name,
          type: Number(t.type)
        }));
        sessionStorage.setItem(AppConstants.SESSION_VAR_ITEM_TYPES, JSON.stringify(itemTypes));
      }
    });
  }

  /** 
  * Set the datasource
  */
  setDataSource(salesList: SaleItemModel[]) {
    this.dataSource = new MatTableDataSource(salesList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    this.changeDetecter.detectChanges();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        const sortColumn = this.transformColumnName(previousState.state.search.sort[0].column);
        this.setSortColumn(sortColumn, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      // console.log("data",this.searchColumFilter)
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('sale_item.code', 'asc');
      this.loadData();
    }

  }

  /**
   * Transform column names from old format to new format
   * @param columnName Original column name
   * @returns Transformed column name
   */
  private transformColumnName(columnName: string): string {
    return this.columnMapping[columnName] || columnName;
  }

  /**
   * Transform incoming request data to use correct column names
   * @param requestData Original request data
   * @returns Transformed request data
   */
  private transformRequestData(requestData: RequestData): RequestData {
    // Transform sort columns
    if (requestData.search?.sort) {
      requestData.search.sort = requestData.search.sort.map(sort => ({
        ...sort,
        column: this.transformColumnName(sort.column)
      }));
    }

    // Transform advanced search columns
    if (requestData.search?.filters?.advSearch) {
      requestData.search.filters.advSearch = requestData.search.filters.advSearch.map(filter => ({
        ...filter,
        column: this.transformColumnName(filter.column)
      }));
    }

    // Transform simple search columns
    if (requestData.search?.filters?.simpleSearch) {
      requestData.search.filters.simpleSearch = requestData.search.filters.simpleSearch.map(filter => ({
        ...filter,
        column: this.transformColumnName(filter.column)
      }));
    }

    return requestData;
  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    // Transform column name if needed
    const transformedColumn = this.transformColumnName(column);

    this.columnSortData.length = 0;
    this.columnSortData.push({ column: transformedColumn, order: direction });
    this.sort.sort({
      id: transformedColumn,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.salesList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.salesList);
  }


  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();

    // Transform sales_channel filter to actual database columns
    // This is necessary because sales_channel doesn't exist in DB
    if (searchParam.advSearch) {
      searchParam.advSearch = this.transformSalesChannelFilter(searchParam.advSearch);
      // console.log(searchParam.advSearch)
    }

    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    // Transform column names to use correct view names
    return this.transformRequestData(requestData);
  }

  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "sale_item.is_system")
    ) {
      defFilter.push({
        column: "sale_item.is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  /**
   * Transform sales channel filter to actual database columns
   * @param advSearch Advanced search filters
   * @returns Transformed filters
   */
  transformSalesChannelFilter(advSearch: ColumnFilter[]): ColumnFilter[] {
    return advSearch.map(filter => {
      if (filter.column === 'sale_item.sales_channel') {
        // Handle array values but keep the array structure for whereIn
        const filterValue = Array.isArray(filter.value) ? filter.value[0] : filter.value;

        if (filterValue === 'instore') {
          // Convert virtual "instore" to actual DB column
          return {
            column: 'sale_item.is_direct_sale_allowed',
            operator: filter.operator || '=',
            value: Array.isArray(filter.value) ? ['1'] : '1', // Keep array structure if original was array
            type: filter.type || 'string'
          };
        } else if (filterValue === 'online') {
          // Convert virtual "online" to actual DB column
          return {
            column: 'sale_item.is_oo_direct_sale_allowed',
            operator: filter.operator || '=',
            value: Array.isArray(filter.value) ? ['1'] : '1', // Keep array structure if original was array
            type: filter.type || 'string'
          };
        }
        // If value doesn't match expected values, return null to filter it out
        return null;
      }
      return filter; // Return unchanged for other filters
    }).filter(filter => filter !== null) as ColumnFilter[]; // Remove null filters
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(salesInfo: SaleItemModel): void {
    const saleItemId = salesInfo.id;
    const message = `Are you sure, you want to delete ` + (salesInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      // console.log(dialogResult);
      if (dialogResult) {
        this.saleItemService.delete(salesInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + salesInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }


  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.saleItemService.getList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        // this.itemCategoryList = response.data.category;
        this.setDataSource(response.data.items);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.salesList[0]);
          this.stateManagerService.setState(this.constructor.name, requestData);

        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }
  // loadData(): void {
  //   this.isLoading = true;
  //   let requestData = this.buildRequestData();
  //   let response = this.saleItemService.getList(requestData).subscribe(response => {
  //     if (response.status == 'SUCCESS') {
  //       this.salesList = response.data.items; // Wrap the object in an array
  //       console.log(response.data.items); // Log data to the console

  //       //this.salesDataSource = new MatTableDataSource(this.salesList);
  //       this.pagingData.length = response.data.total_count;
  //       if (this.pagingData.length == 0) {
  //         let snackBarData: SnackBarData = {
  //           message: 'No data found. Please remove or change the filter if any.',
  //           title: 'No Data!!!',
  //           type: 'warn'
  //         }
  //         this.snackBarService.openSnackBar(snackBarData);
  //         this.selectedItem = undefined;
  //       } else {
  //         this.onRowSelected(this.salesList[0])
  //       }
  //     } else {
  //       let snackBarData: SnackBarData = {
  //         message: response.message,
  //         title: 'Failed!!!',
  //       }
  //       this.snackBarService.openSnackBar(snackBarData);
  //     }
  //     this.isLoading = false;
  //   });

  // }

  /**
  * On kitchenInfo selected
  * @param kitchenInfo 
  */
  onRowSelected(salesInfo: SaleItemModel): void {
    this.selectedItem = salesInfo;
    this.showSummaryPanel = true;
  }

  openShopPricesModal(item: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.dialog.open(ShopPricePopupComponent, {
      width: '700px',
      maxHeight: '90vh',
      data: {
        saleItemId: item.id,
        itemName: item.name
      }
    });
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(saleInfo: SaleItemModel): void {
    if (saleInfo.is_group_item == true) {
      this.onGroupItemEditClick(saleInfo)
    } else {
      this.router.navigate(['product/sale-item-edit', saleInfo.id]);
    }
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }
  /**
   * On Add clicked
   * Show the dialog to enter new kitchen
   */
  addClicked(): void {

    this.router.navigate(['product/sale-item-edit', 0]);

  }
  exportClicked() {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }

    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.saleItemService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'saleItems.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to export items data. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

  /**
   * Opens the sale items popup for a group item
   * @param groupItem The group item data
   */
  onGroupItemClick(groupItem: any, event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(GroupItemListPopupComponent, {
      width: '800px',
      // height: '66vh',
      data: {
        groupItemId: groupItem.id,
        groupName: groupItem.name
      },
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the result if needed
        console.log('Popup closed with result:');
      }
    });
  }
  onGroupItemEditClick(groupItem: any) {
    // event.preventDefault();
    // event.stopPropagation();

    const dialogRef = this.dialog.open(GroupItemEditPopupComponent, {
      width: '800px',
      // height: '90vh',
      data: {
        groupItemId: groupItem.id,
        groupName: groupItem.name
      },
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the result if needed
        console.log('Popup closed with result:');
      }
    });
  }
}


